/* MRC Hero Coverflow - 2026-05-17 */
(function () {
  'use strict';

  function initCoverflow(root) {
    var autoplay = root.dataset.cfAutoplay === 'true';
    var interval = parseInt(root.dataset.cfInterval, 10) || 6000;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isMobile = window.matchMedia('(max-width: 767px)').matches;

    var rail = root.querySelector('[data-cf-rail]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-cf-card]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-cf-dot]'));
    var prevBtn = root.querySelector('[data-cf-prev]');
    var nextBtn = root.querySelector('[data-cf-next]');
    var pauseBtn = root.querySelector('[data-cf-pause]');
    var revealContainers = Array.prototype.slice.call(root.querySelectorAll('[data-cf-products]'));

    if (cards.length === 0) return;

    var active = 0;
    var total = cards.length;
    var timer = null;
    var paused = false;
    var dragSuppressClick = false;

    function hydrateCardImage(card) {
      if (!card) return;
      var img = card.querySelector('img[data-cf-src]');
      if (!img) return;

      if (img.dataset.cfSrcset) img.srcset = img.dataset.cfSrcset;
      img.src = img.dataset.cfSrc;
      img.removeAttribute('data-cf-src');
      img.removeAttribute('data-cf-srcset');
    }

    function hydrateVisibleCards(index) {
      hydrateCardImage(cards[index]);
      if (isMobile) return;

      [-2, -1, 1, 2].forEach(function (offset) {
        hydrateCardImage(cards[((index + offset) % total + total) % total]);
      });
    }

    function hydrateAdjacentCards() {
      hydrateCardImage(cards[((active - 1) % total + total) % total]);
      hydrateCardImage(cards[(active + 1) % total]);
    }

    function setPositions() {
      cards.forEach(function (card, i) {
        var diff = ((i - active) % total + total) % total;
        var pos, dir;

        if (diff === 0) { pos = 'active'; dir = 'center'; }
        else if (diff === 1) { pos = 'side'; dir = 'right'; }
        else if (diff === total - 1) { pos = 'side'; dir = 'left'; }
        else if (diff === 2) { pos = 'edge'; dir = 'right'; }
        else if (diff === total - 2) { pos = 'edge'; dir = 'left'; }
        else { pos = 'hidden'; dir = (diff <= total / 2) ? 'right' : 'left'; }

        card.dataset.cfPosition = pos;
        card.dataset.cfDirection = dir;
        card.setAttribute('aria-current', pos === 'active' ? 'true' : 'false');
        // Layout-Reset: kein display:none, kein order mehr - alles via CSS-Transforms
        card.style.display = '';
        card.style.order = '';
      });

      dots.forEach(function (d, i) {
        d.setAttribute('aria-selected', i === active ? 'true' : 'false');
      });

      revealContainers.forEach(function (rc, i) {
        var visible = i === active;
        rc.dataset.cfVisible = visible ? 'true' : 'false';
        rc.style.display = visible ? '' : 'none';
      });
    }

    function goTo(index) {
      var nextActive = ((index % total) + total) % total;
      hydrateVisibleCards(nextActive);
      active = nextActive;
      setPositions();
    }

    function next() { goTo(active + 1); }
    function prev() { goTo(active - 1); }

    function startAutoplay() {
      if (!autoplay || isMobile || reducedMotion || paused) return;
      stopAutoplay();
      timer = setInterval(next, interval);
    }

    function stopAutoplay() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function pauseForUser() {
      paused = true;
      stopAutoplay();
      if (pauseBtn) {
        pauseBtn.textContent = 'Play';
        pauseBtn.setAttribute('aria-pressed', 'true');
      }
    }

    if (nextBtn) nextBtn.addEventListener('click', function () { pauseForUser(); next(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { pauseForUser(); prev(); });

    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { pauseForUser(); goTo(i); });
    });

    cards.forEach(function (card, i) {
      card.addEventListener('click', function (ev) {
        if (dragSuppressClick) { ev.preventDefault(); ev.stopPropagation(); return; }
        if (i !== active) {
          ev.preventDefault();
          pauseForUser();
          goTo(i);
        }
      });
    });

    if (pauseBtn) {
      pauseBtn.addEventListener('click', function () {
        paused = !paused;
        pauseBtn.textContent = paused ? 'Play' : 'Pause';
        pauseBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        if (paused) stopAutoplay(); else startAutoplay();
      });
    }

    root.querySelectorAll('[data-mrc-card-wrap]').forEach(function (wrap) {
      var group = wrap.querySelector('[data-mrc-card-variants]');
      if (!group) return;
      var priceEl = wrap.querySelector('[data-mrc-card-price]');
      var cartInput = wrap.querySelector('[data-mrc-cart-input]');

      group.querySelectorAll('button[data-variant-id]').forEach(function (btn) {
        btn.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          group.querySelectorAll('button').forEach(function (button) {
            button.classList.remove('mrc-home-card__variant--active');
            button.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('mrc-home-card__variant--active');
          btn.setAttribute('aria-pressed', 'true');
          if (priceEl && btn.dataset.variantPrice) priceEl.textContent = btn.dataset.variantPrice + '\u00a0€';
          if (cartInput && btn.dataset.variantId) cartInput.value = btn.dataset.variantId;
        });
      });
    });

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { pauseForUser(); next(); }
      if (e.key === 'ArrowLeft')  { pauseForUser(); prev(); }
    });

    // ===== GREIF-/WISCHFUNKTION: Live-Folgen + Snap + Schwung (Maus, Touch, Trackpad) =====
    var dragState = null;
    var stepW = 220;
    function measureStep() {
      var a = root.querySelector('[data-cf-card][data-cf-position="active"]');
      var s = root.querySelector('[data-cf-card][data-cf-position="side"][data-cf-direction="right"]');
      if (a && s) {
        var ar = a.getBoundingClientRect(), sr = s.getBoundingClientRect();
        var d = Math.abs((sr.left + sr.width / 2) - (ar.left + ar.width / 2));
        if (d > 40) stepW = d;
      } else if (rail) {
        stepW = Math.max(160, rail.offsetWidth * 0.26);
      }
    }
    function setCardTransition(fast) {
      cards.forEach(function (c) {
        c.style.transition = fast ? 'transform 240ms cubic-bezier(0.32,0.72,0,1), box-shadow 240ms, opacity 240ms' : '';
      });
    }
    if (rail) {
      rail.style.touchAction = 'pan-y';
      rail.style.cursor = 'grab';
      rail.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        hydrateAdjacentCards();
        measureStep();
        dragState = { baseX: e.clientX, startX: e.clientX, lastX: e.clientX, lastT: performance.now(), vx: 0, moved: false, captured: false };
        rail.style.transition = 'none';
        rail.style.cursor = 'grabbing';
        setCardTransition(true);
        pauseForUser();
      });
      rail.addEventListener('pointermove', function (e) {
        if (!dragState) return;
        var now = performance.now(), dt = now - dragState.lastT;
        if (dt > 0) dragState.vx = (e.clientX - dragState.lastX) / dt;
        dragState.lastX = e.clientX; dragState.lastT = now;
        if (Math.abs(e.clientX - dragState.startX) > 4) { if (!dragState.captured) { try { rail.setPointerCapture(e.pointerId); dragState.captured = true; } catch (err) {} } dragState.moved = true; }
        var dx = e.clientX - dragState.baseX;
        var guard = 0;
        while (dx <= -stepW && guard++ < 12) { next(); dragState.baseX -= stepW; dx = e.clientX - dragState.baseX; }
        while (dx >= stepW && guard++ < 12) { prev(); dragState.baseX += stepW; dx = e.clientX - dragState.baseX; }
        rail.style.transform = 'translateX(' + dx + 'px)';
      });
      function endDrag(e) {
        if (!dragState) return;
        var cx = (e && e.clientX != null) ? e.clientX : dragState.lastX;
        var restDx = cx - dragState.baseX;
        var v = dragState.vx;
        var moved = dragState.moved;
        try { if (e) rail.releasePointerCapture(e.pointerId); } catch (err) {}
        dragState = null;
        var restNext = restDx <= -stepW * 0.35 ? 1 : (restDx >= stepW * 0.35 ? -1 : 0);
        var flickNext = Math.round(-v * 0.25);
        if (flickNext > 4) flickNext = 4; if (flickNext < -4) flickNext = -4;
        var totalNext = restNext + flickNext;
        setCardTransition(false);
        rail.style.transition = 'transform 700ms cubic-bezier(0.32,0.72,0,1)';
        rail.style.transform = 'translateX(0px)';
        rail.style.cursor = 'grab';
        if (totalNext !== 0) goTo(active + totalNext);
        if (moved) { dragSuppressClick = true; setTimeout(function () { dragSuppressClick = false; }, 80); }
      }
      rail.addEventListener('pointerup', endDrag);
      rail.addEventListener('pointercancel', endDrag);
    }

    // Trackpad/Mausrad quer (zusaetzlich, diskret) - vertikales Scrollen bleibt unberuehrt
    var wheelAccum = 0, wheelLock = false, wheelLastT = 0, wheelLockT = 0;
    root.addEventListener('wheel', function (e) {
      var dx = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : (e.shiftKey ? e.deltaY : 0);
      if (dx === 0) return;
      e.preventDefault();
      var now = performance.now();
      var gap = now - wheelLastT;
      wheelLastT = now;
      var mag = Math.abs(dx);
      // Klare Pause zwischen zwei Wischern -> neue Geste, sofort frei
      if (gap > 130) { wheelAccum = 0; wheelLock = false; }
      // Nach einem Sprung gesperrt: NICHT auf komplettes Stillstehen warten (das dauert Sekunden).
      // Entsperren, sobald die Inertia abklingt (kleiner Delta) ODER Sicherheits-Timeout -> sofort re-wischbar.
      if (wheelLock) {
        if (mag < 7 || now - wheelLockT > 550) wheelLock = false;
        wheelAccum = 0; // Inertia waehrend der Sperre verpufft, kein Aufstauen
        return;
      }
      wheelAccum += dx;
      if (Math.abs(wheelAccum) > 35) {
        pauseForUser();
        (wheelAccum > 0 ? next() : prev());
        wheelAccum = 0;
        wheelLock = true; wheelLockT = now; // genau EIN Sprung pro Wisch
      }
    }, { passive: false });

    window.addEventListener('resize', function () {
      isMobile = window.matchMedia('(max-width: 767px)').matches;
      if (isMobile) stopAutoplay();
      else {
        hydrateVisibleCards(active);
        startAutoplay();
      }
    });

    hydrateVisibleCards(active);
    setPositions();
    startAutoplay();
  }

  function bootAll() {
    var roots = document.querySelectorAll('[data-mrc-hero-coverflow]');
    roots.forEach(initCoverflow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }
})();
